import { render, staticRenderFns } from "./RelatedEventNewsItem.vue?vue&type=template&id=fbfeadcc&scoped=true"
import script from "./RelatedEventNewsItem.vue?vue&type=script&lang=js"
export * from "./RelatedEventNewsItem.vue?vue&type=script&lang=js"
import style0 from "./RelatedEventNewsItem.vue?vue&type=style&index=0&id=fbfeadcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbfeadcc",
  null
  
)

export default component.exports